import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Input,
  Table,
  Spinner,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withRouter } from "react-router-dom"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import ButtonSpinner from "components/ButtonSpinner"
import * as productAction from "../../../store/b3RoZXJCcmFuY2hEY/actions"
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import "./styles.scss"
import api from "helpers/Api"
import ReactDOM from "react-dom"
import TabComponent from "./TabComponent"

const OtherBranchDataPendingReport = (props) => {
  const { searchBtnStyle, dispatch } = props
  const title = "Other Branch Data Pending Report"
  const [productStatusData, setProductStatusData] = useState({
    eventFromDate: "",
    eventToDate: "",
  })
  //Fetching API
  useEffect(() => {
    dispatch(productAction.loadProductStatus())
  }, [])

  //date format
  const update = useSelector(
    (specificstate) => specificstate.otherBranchDataPendingReport
  )

  //product_data
  const { product_data = [] } = update

  //Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : "DD/MM/YYYY"

  const handleChange = (e) => {
    setProductStatusData({
      ...productStatusData,
      [e.target.name]: e.target.value,
    })
  }

  const [downloadLoading, setDownloadLoading] = useState(false)

  //Search value

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [btnLoader, setBtnLoader] = useState(false)
  const [searchValue, setSearchValue] = useState({})
  console.log(dateFormat)
  console.log(searchValue)
  const handleFilter = (e) => {
    e.preventDefault()

    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValue(searchvalue)
    dispatch(productAction.loadProductStatus(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 3000)
  }

  //reset

  const resetForm = () => {
    setSearchInput("")

    setProductStatusData({
      ...productStatusData,
      eventFromDate: "",
      eventToDate: "",
    })
    dispatch(productAction.loadProductStatus())
  }

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      productAction.loadProductStatus({
        searchFilter: searchInput,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    setDownloadLoading(true)
    var searchFromDate =
      productStatusData && productStatusData.eventFromDate
        ? moment(productStatusData.eventFromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      productStatusData && productStatusData.eventToDate
        ? moment(productStatusData.eventToDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }

    api
      .post(`/other_branch_data_pending_report`, searchvalue)
      .then((response) => {
        const product_data = !isEmpty(response.data.data)
          ? response.data.data
          : []
        //table
        const ExportDataTable = product_data.map((data, index) => {
          const services = data.count || {}

          // Retrieve event dates and format them
          const tpEventDate = services["TRADITIONAL PHOTOGRAPHY"]
            ? services["TRADITIONAL PHOTOGRAPHY"].oldestEventDate
            : ""
          const tpEventDateValue = tpEventDate
            ? moment(tpEventDate).format(dateFormat)
            : "--"

          const cpEventDate = services["CANDID PHOTOGRAPHY"]
            ? services["CANDID PHOTOGRAPHY"].oldestEventDate
            : ""
          const cpEventDateValue = cpEventDate
            ? moment(cpEventDate).format(dateFormat)
            : "--"

          const tvEventDate = services["TRADITIONAL VIDEOGRAPHY"]
            ? services["TRADITIONAL VIDEOGRAPHY"].oldestEventDate
            : ""
          const tvEventDateValue = tvEventDate
            ? moment(tvEventDate).format(dateFormat)
            : "--"

          const cEventDate = services["CINEMATOGRAPHY"]
            ? services["CINEMATOGRAPHY"].oldestEventDate
            : ""
          const cEventDateValue = cEventDate
            ? moment(cEventDate).format(dateFormat)
            : "--"
          const hEventDate = services["HELICAM"]
            ? services["HELICAM"].oldestEventDate
            : ""
          const hEventDateValue = hEventDate
            ? moment(hEventDate).format(dateFormat)
            : "--"

          const muEventDate = services["MIXER UNIT"]
            ? services["MIXER UNIT"].oldestEventDate
            : ""
          const muEventDateValue = muEventDate
            ? moment(muEventDate).format(dateFormat)
            : "--"

          const lsEventDate = services["LIVE STREAMING"]
            ? services["LIVE STREAMING"].oldestEventDate
            : ""
          const lsEventDateValue = lsEventDate
            ? moment(lsEventDate).format(dateFormat)
            : "--"

          // Service counts
          const tpCount = services["TRADITIONAL PHOTOGRAPHY"]
            ? services["TRADITIONAL PHOTOGRAPHY"].serviceCount
            : 0
          const tpuniqueClientCount = services["TRADITIONAL PHOTOGRAPHY"]
            ? services["TRADITIONAL PHOTOGRAPHY"].uniqueClientCount
            : 0
          const cpCount = services["CANDID PHOTOGRAPHY"]
            ? services["CANDID PHOTOGRAPHY"].serviceCount
            : 0
          const cpuniqueClientCount = services["CANDID PHOTOGRAPHY"]
            ? services["CANDID PHOTOGRAPHY"].uniqueClientCount
            : 0
          const tvCount = services["TRADITIONAL VIDEOGRAPHY"]
            ? services["TRADITIONAL VIDEOGRAPHY"].serviceCount
            : 0
          const tvuniqueClientCount = services["TRADITIONAL VIDEOGRAPHY"]
            ? services["TRADITIONAL VIDEOGRAPHY"].uniqueClientCount
            : 0
          const cCount = services["CINEMATOGRAPHY"]
            ? services["CINEMATOGRAPHY"].serviceCount
            : 0
          const cuniqueClientCount = services["CINEMATOGRAPHY"]
            ? services["CINEMATOGRAPHY"].uniqueClientCount
            : 0
          const hCount = services["HELICAM"]
            ? services["HELICAM"].serviceCount
            : 0
          const huniqueClientCount = services["HELICAM"]
            ? services["HELICAM"].uniqueClientCount
            : 0
          const muCount = services["MIXER UNIT"]
            ? services["MIXER UNIT"].serviceCount
            : 0
          const muuniqueClientCount = services["MIXER UNIT"]
            ? services["MIXER UNIT"].uniqueClientCount
            : 0
          const lsCount = services["LIVE STREAMING"]
            ? services["LIVE STREAMING"].serviceCount
            : 0
          const lsuniqueClientCount = services["LIVE STREAMING"]
            ? services["LIVE STREAMING"].uniqueClientCount
            : 0

          const rowTotal =
            tpCount +
            tpuniqueClientCount +
            cpCount +
            cpuniqueClientCount +
            tvCount +
            tvuniqueClientCount +
            cCount +
            cuniqueClientCount +
            hCount +
            huniqueClientCount +
            muCount +
            muuniqueClientCount +
            lsCount +
            lsuniqueClientCount
          const count = rowTotal // Overall count for the row

          return {
            sNo: index + 1,
            branchName: data.statusName || "--",
            tpCount,
            tpuniqueClientCount,
            tpEventDateValue,
            cpCount,
            cpuniqueClientCount,
            cpEventDateValue,
            tvCount,
            tvuniqueClientCount,
            tvEventDateValue,
            cCount,
            cuniqueClientCount,
            cEventDateValue,
            hCount,
            huniqueClientCount,
            hEventDateValue,
            muCount,
            muuniqueClientCount,
            muEventDateValue,
            lsCount,
            lsuniqueClientCount,
            lsEventDateValue,
            rowTotal,
            count,
          }
        })

        // Column wise totals
        const columnTotals = {
          tpCount: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["TRADITIONAL PHOTOGRAPHY"]?.serviceCount || 0),
            0
          ),
          tpuniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["TRADITIONAL PHOTOGRAPHY"]?.uniqueClientCount || 0),
            0
          ),
          tpEventDateValue: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["TRADITIONAL PHOTOGRAPHY"]?.eventDateValue || 0),
            0
          ),

          cpCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["CANDID PHOTOGRAPHY"]?.serviceCount || 0),
            0
          ),
          cpuniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["CANDID PHOTOGRAPHY"]?.uniqueClientCount || 0),
            0
          ),
          cpEventDateValue: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["CANDID PHOTOGRAPHY"]?.eventDateValue || 0),
            0
          ),

          tvCount: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["TRADITIONAL VIDEOGRAPHY"]?.serviceCount || 0),
            0
          ),
          tvuniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["TRADITIONAL VIDEOGRAPHY"]?.uniqueClientCount || 0),
            0
          ),
          tvEventDateValue: product_data.reduce(
            (sum, data) =>
              sum +
              (data.count?.["TRADITIONAL VIDEOGRAPHY"]?.eventDateValue || 0),
            0
          ),

          cCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["CINEMATOGRAPHY"]?.serviceCount || 0),
            0
          ),
          cuniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["CINEMATOGRAPHY"]?.uniqueClientCount || 0),
            0
          ),
          cEventDateValue: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["CINEMATOGRAPHY"]?.eventDateValue || 0),
            0
          ),

          hCount: product_data.reduce(
            (sum, data) => sum + (data.count?.["HELICAM"]?.serviceCount || 0),
            0
          ),
          huniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["HELICAM"]?.uniqueClientCount || 0),
            0
          ),
          hEventDateValue: product_data.reduce(
            (sum, data) => sum + (data.count?.["HELICAM"]?.eventDateValue || 0),
            0
          ),

          muCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["MIXER UNIT"]?.serviceCount || 0),
            0
          ),
          muuniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["MIXER UNIT"]?.uniqueClientCount || 0),
            0
          ),
          muEventDateValue: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["MIXER UNIT"]?.eventDateValue || 0),
            0
          ),

          lsCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["LIVE STREAMING"]?.serviceCount || 0),
            0
          ),
          lsuniqueClientCount: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["LIVE STREAMING"]?.uniqueClientCount || 0),
            0
          ),
          lsEventDateValue: product_data.reduce(
            (sum, data) =>
              sum + (data.count?.["LIVE STREAMING"]?.eventDateValue || 0),
            0
          ),
        }

        columnTotals.total = Object.values(columnTotals).reduce(
          (sum, value) => sum + value,
          0
        )
        setTimeout(() => {
          // first and second row
          let headerData = [
            "#,Traditional Photography,, ,Candid Photography,, ,Traditional Videography, ,,Cinematography,, ,Helicam, ,,Mixer Unit,, ,Live Streaming,,,Total", // First row header
            "Branch Name,Service Count,Client Count,Oldest Event Date,Service Count,Client Count,Oldest Event Date,Service Count,Client Count,Oldest Event Date,Service Count,Client Count,Oldest Event Date,Service Count,Client Count,Oldest Event Date,Service Count,Client Count,Oldest Event Date,Service Count,Client Count,Oldest Event Date,Total ,", // Second row header
          ]

          // Data rows
          let csvRows = ExportDataTable.map((row) => {
            return [
              row.branchName,
              row.tpCount,
              row.tpuniqueClientCount,
              row.tpEventDateValue,
              row.cpCount,
              row.cpuniqueClientCount,
              row.cpEventDateValue,
              row.tvCount,
              row.tvuniqueClientCount,
              row.tvEventDateValue,
              row.cCount,
              row.cuniqueClientCount,
              row.cEventDateValue,
              row.hCount,
              row.huniqueClientCount,
              row.hEventDateValue,
              row.muCount,
              row.muuniqueClientCount,
              row.muEventDateValue,
              row.lsCount,
              row.lsuniqueClientCount,
              row.lsEventDateValue,
              row.rowTotal,
              // Corrected to avoid extra unwanted column
            ].join(",")
          })

          // Add total row
          csvRows.push(
            [
              "Total",
              columnTotals.tpCount,
              columnTotals.tpuniqueClientCount,
              "",

              columnTotals.cpCount,
              columnTotals.cpuniqueClientCount,
              "",
              columnTotals.tvCount,
              columnTotals.tvuniqueClientCount,
              "",
              columnTotals.cCount,
              columnTotals.cuniqueClientCount,
              "",
              columnTotals.hCount,
              columnTotals.huniqueClientCount,
              "",
              columnTotals.muCount,
              columnTotals.muuniqueClientCount,
              "",
              columnTotals.lsCount,
              columnTotals.lsuniqueClientCount,
              "",
              columnTotals.total,
              "", // No total for Count
            ].join(",")
          )

          // Combine header and data into CSV content
          const csvContent = [...headerData, ...csvRows].join("\n")

          // Trigger the file download
          downloadFile({
            data: csvContent,
            fileName: "OtherBranchDataReport.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1500)
        return response.data
      })
      .catch((error) => {
        setDownloadLoading(false)
        Promise.reject(error)
      })
  } 
 
  const handleClickTab = (tableData) => {
    const statusName = tableData.serviceName
  


    api
      .post(`/other_branch_data_pending_report_details`, tableData)
      .then((response) => {
        const statusData = !isEmpty(response.data.data)
          ? response.data.data
          : []
        setTimeout(() => {
          // Use the current value of statusData, which should be updated due to the useEffect

          const newTab = window.open("", "_blank", "width=600,height=400")
          if (newTab) {
            const container = newTab.document.createElement("div")
            newTab.document.body.appendChild(container)
            ReactDOM.render(
              <TabComponent
                data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={tableData}
                name={statusName}
                dateFormat={dateFormat}
              />,
              container
            )
            newTab.document.title = "EVENT-MONTH-WISE-PRODUCT-STATUS-REPORT"
          }
        }, 2000)
      })
      .catch((error) => {
        Promise.reject(error)
        const newTab = window.open("", "_blank", "width=600,height=400")
        if (newTab) {
          const container = newTab.document.createElement("div")
          newTab.document.body.appendChild(container)
          ReactDOM.render(
            <TabComponent
             //  data={statusData} // Use statusData directly here
                dispatch={dispatch}
                statusPayload={tableData}
                name={statusName}
                dateFormat={dateFormat}
            />,
            container
          )
          newTab.document.title = "FLR-PENDING-DATA-REPORT"
        }
      })
  }
  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event From Date"}
                        >
                          {"Event From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventFromDate"
                        value={productStatusData.eventFromDate}
                        max={productStatusData.eventToDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className={"form-label"}
                          htmlFor={"Event To Date"}
                        >
                          {"Event To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        name="eventToDate"
                        value={productStatusData.eventToDate}
                        min={productStatusData.eventFromDate}
                        onChange={(e) => handleChange(e)}
                        placeholder="Enter "
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-3"
                          onClick={() => {
                            resetForm()
                          }}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleFilter(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBtnStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>

                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>
                <Row>
                  <Col md="4" lg="4" sm="12"></Col>
                  <Col
                    md="8"
                    lg="8"
                    sm="12"
                    style={{ marginBottom: "20px", marginTop: "-41px" }}
                  >
                    <div
                      style={{
                        float: "right",
                      }}
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={exportToCsv}
                        id="download"
                        style={{
                          backgroundColor: "#e40d8c",
                          color: "white",
                          border: "none",
                        }}
                      >
                        Download
                      </Button>
                    </div>
                  </Col>
                </Row>

                <Col md="12" lg="12" xl="12" className="mt-3">
                  <Table responsive bordered>
                    <thead>
                      <tr>
                        <th
                          colSpan={1}
                          style={{
                            minWidth: "150px",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#F8F8FB",
                          }}
                        >
                          {" "}
                          #{" "}
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Traditional Photography
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Candid Photography
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Traditional Videography
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Cinematography
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Helicam
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Mixer Unit
                        </th>
                        <th colSpan={3} style={{ minWidth: "300px" }}>
                          Live Streaming
                        </th>
                        <th colSpan={1} style={{ minWidth: "150px" }}>
                          Total
                        </th>
                      </tr>
                      <tr>
                        <th
                          style={{
                            minWidth: "150px",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#F8F8FB",
                          }}
                        >
                          Branch
                        </th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "100px" }}>Service Count</th>
                        <th style={{ minWidth: "100px" }}>Client Count</th>
                        <th style={{ minWidth: "150px" }}>Oldest Event Date</th>
                        <th style={{ minWidth: "150px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {product_data && product_data.length > 0 ? (
                        product_data.map((data, index) => {
                          const services = data?.count || {}
                          //oldestEventDate

                          const tpCount = services["TRADITIONAL PHOTOGRAPHY"]
                            ? services["TRADITIONAL PHOTOGRAPHY"].serviceCount
                            : 0
                          const tpuniqueClientCount = services[
                            "TRADITIONAL PHOTOGRAPHY"
                          ]
                            ? services["TRADITIONAL PHOTOGRAPHY"]
                              .uniqueClientCount
                            : 0
                          const tpEventDate = services[
                            "TRADITIONAL PHOTOGRAPHY"
                          ]
                            ? services["TRADITIONAL PHOTOGRAPHY"]
                              .oldestEventDate
                            : ""
                          const tpEventDateValue = tpEventDate
                            ? moment(tpEventDate).format(dateFormat)
                            : "--"
                          const tpData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "TRADITIONAL PHOTOGRAPHY"
                          }
                        

                          const cpCount = services["CANDID PHOTOGRAPHY"]
                            ? services["CANDID PHOTOGRAPHY"].serviceCount
                            : 0
                          const cpuniqueClientCount = services[
                            "CANDID PHOTOGRAPHY"
                          ]
                            ? services["CANDID PHOTOGRAPHY"].uniqueClientCount
                            : 0
                          const cpEventDate = services["CANDID PHOTOGRAPHY"]
                            ? services["CANDID PHOTOGRAPHY"].oldestEventDate
                            : ""
                          const cpEventDateValue = cpEventDate
                            ? moment(cpEventDate).format(dateFormat)
                            : "--"
                          const cpData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "CANDID PHOTOGRAPHY"
                          }
                       

                          const tvCount = services["TRADITIONAL VIDEOGRAPHY"]
                            ? services["TRADITIONAL VIDEOGRAPHY"].serviceCount
                            : 0
                          const tvuniqueClientCount = services[
                            "TRADITIONAL VIDEOGRAPHY"
                          ]
                            ? services["TRADITIONAL VIDEOGRAPHY"]
                              .uniqueClientCount
                            : 0
                          const tvEventDate = services[
                            "TRADITIONAL VIDEOGRAPHY"
                          ]
                            ? services["TRADITIONAL VIDEOGRAPHY"]
                              .oldestEventDate
                            : ""
                          const tvEventDateValue = tvEventDate
                            ? moment(tvEventDate).format(dateFormat)
                            : "--"
                          const tvData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "TRADITIONAL VIDEOGRAPHY"
                          }
                        

                          const cCount = services["CINEMATOGRAPHY"]
                            ? services["CINEMATOGRAPHY"].serviceCount
                            : 0
                          const cuniqueClientCount = services["CINEMATOGRAPHY"]
                            ? services["CINEMATOGRAPHY"].uniqueClientCount
                            : 0
                          const cEventDate = services["CINEMATOGRAPHY"]
                            ? services["CINEMATOGRAPHY"].oldestEventDate
                            : ""
                          const cEventDateValue = cEventDate
                            ? moment(cEventDate).format(dateFormat)
                            : "--"
                          const cData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "CINEMATOGRAPHY"
                          }
                      

                          const hCount = services["HELICAM"]
                            ? services["HELICAM"].serviceCount
                            : 0
                          const huniqueClientCount = services["HELICAM"]
                            ? services["HELICAM"].uniqueClientCount
                            : 0
                          const hEventDate = services["HELICAM"]
                            ? services["HELICAM"].oldestEventDate
                            : ""
                          const hEventDateValue = hEventDate
                            ? moment(hEventDate).format(dateFormat)
                            : "--"
                          const hData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "HELICAM"
                          }
                         

                          const muCount = services["MIXER UNIT"]
                            ? services["MIXER UNIT"].serviceCount
                            : 0
                          const muuniqueClientCount = services["MIXER UNIT"]
                            ? services["MIXER UNIT"].uniqueClientCount
                            : 0
                          const muEventDate = services["MIXER UNIT"]
                            ? services["MIXER UNIT"].oldestEventDate
                            : ""
                          const muEventDateValue = muEventDate
                            ? moment(muEventDate).format(dateFormat)
                            : "--"
                          const muData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "MIXER UNIT"
                          }
                        

                          const lsCount = services["LIVE STREAMING"]
                            ? services["LIVE STREAMING"].serviceCount
                            : 0
                          const lsuniqueClientCount = services["LIVE STREAMING"]
                            ? services["LIVE STREAMING"].uniqueClientCount
                            : 0
                          const lsEventDate = services["LIVE STREAMING"]
                            ? services["LIVE STREAMING"].oldestEventDate
                            : ""
                          const lsEventDateValue = lsEventDate
                            ? moment(lsEventDate).format(dateFormat)
                            : "--"
                          const lsData = {
                            serviceLevelStatusId: data.statusId,
                            serviceName: "LIVE STREAMING"
                          }
                       


                          const rowTotal =
                            tpCount +
                            tpuniqueClientCount +
                            cpCount +
                            cpuniqueClientCount +
                            tvCount +
                            tvuniqueClientCount +
                            cCount +
                            cuniqueClientCount +
                            hCount +
                            huniqueClientCount +
                            muCount +
                            muuniqueClientCount +
                            lsCount +
                            lsuniqueClientCount

                          return (
                            <tr key={index}>
                              <th
                                scope="row"
                                style={{
                                  minWidth: "150px",
                                  position: "sticky",
                                  left: 0,
                                  zIndex: 1,
                                  backgroundColor: "#F8F8FB",
                                }}
                              >
                                {data.statusName || "--"}
                              </th>
                              <td
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                                onClick={()=>handleClickTab(tpData)}
                              >
                                {tpCount}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                }}
                             
                              >
                                {tpuniqueClientCount}
                              </td>
                              <td>{tpEventDateValue}</td>
                              <td     onClick={()=>handleClickTab(cpData)}
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                              >
                                {cpCount}
                              </td>
                              <td 
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                }}
                              >
                                {cpuniqueClientCount}
                              </td>
                              <td>{cpEventDateValue}</td>
                              <td   onClick={()=>handleClickTab(tvData)}
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                              >
                                {tvCount}
                              </td>
                              <td 
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                 
                                }}
                              >
                                {tvuniqueClientCount}
                              </td>
                              <td>{tvEventDateValue}</td>
                              <td onClick={()=>handleClickTab(cData)}
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                              >
                                {cCount}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                }}
                              >
                                {cuniqueClientCount}
                              </td>
                              <td>{cEventDateValue}</td>
                              <td onClick={()=>handleClickTab(hData)}
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                              >
                                {hCount}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                }}
                              >
                                {huniqueClientCount}
                              </td>
                              <td>{hEventDateValue}</td>
                              <td onClick={()=>handleClickTab(muData)}
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                              >
                                {muCount}
                              </td>
                              <td 
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                }}
                              >
                                {muuniqueClientCount}
                              </td>
                              <td>{muEventDateValue}</td>
                              <td onClick={()=>handleClickTab(lsData)}
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                  color: "#e40d8c",
                                  textDecoration: "underline",
                                }}
                              >
                                {lsCount}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                  minWidth: "100px",
                                }}
                              >
                                {lsuniqueClientCount}
                              </td>
                              <td>{lsEventDateValue}</td>
                              <td
                                style={{
                                  fontWeight: "bold",
                                  textAlign: "center",
                                }}
                              >
                                {rowTotal}
                              </td>
                            </tr>
                          )
                        })
                      ) : (
                        <tr>
                          <td className="text-align-center" colSpan={23}>
                            No Results Found
                          </td>
                        </tr>
                      )}
                      <tr>
                        <th
                          style={{
                            minWidth: "150px",
                            position: "sticky",
                            left: 0,
                            zIndex: 1,
                            backgroundColor: "#F8F8FB",
                          }}
                        >
                          Total
                        </th>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["TRADITIONAL PHOTOGRAPHY"]
                                ? services["TRADITIONAL PHOTOGRAPHY"]
                                  .serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["TRADITIONAL PHOTOGRAPHY"]
                                ? services["TRADITIONAL PHOTOGRAPHY"]
                                  .uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["CANDID PHOTOGRAPHY"]
                                ? services["CANDID PHOTOGRAPHY"].serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["CANDID PHOTOGRAPHY"]
                                ? services["CANDID PHOTOGRAPHY"]
                                  .uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["TRADITIONAL VIDEOGRAPHY"]
                                ? services["TRADITIONAL VIDEOGRAPHY"]
                                  .serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["TRADITIONAL VIDEOGRAPHY"]
                                ? services["TRADITIONAL VIDEOGRAPHY"]
                                  .uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["CINEMATOGRAPHY"]
                                ? services["CINEMATOGRAPHY"].serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["CINEMATOGRAPHY"]
                                ? services["CINEMATOGRAPHY"].uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["HELICAM"]
                                ? services["HELICAM"].serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["HELICAM"]
                                ? services["HELICAM"].uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["MIXER UNIT"]
                                ? services["MIXER UNIT"].serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["MIXER UNIT"]
                                ? services["MIXER UNIT"].uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["LIVE STREAMING"]
                                ? services["LIVE STREAMING"].serviceCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td style={{ textAlign: "center", color: "#000" }}>
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            return (
                              sum +
                              (services["LIVE STREAMING"]
                                ? services["LIVE STREAMING"].uniqueClientCount
                                : 0)
                            )
                          }, 0)}
                        </td>
                        <td></td>

                        <td
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            color: "#000",
                          }}
                        >
                          {product_data.reduce((sum, data) => {
                            const services = data?.count || {}
                            const rowTotal =
                              (services["TRADITIONAL PHOTOGRAPHY"]
                                ? services["TRADITIONAL PHOTOGRAPHY"]
                                  .serviceCount
                                : 0) +
                              (services["TRADITIONAL PHOTOGRAPHY"]
                                ? services["TRADITIONAL PHOTOGRAPHY"]
                                  .uniqueClientCount
                                : 0) +
                              (services["CANDID PHOTOGRAPHY"]
                                ? services["CANDID PHOTOGRAPHY"].serviceCount
                                : 0) +
                              (services["CANDID PHOTOGRAPHY"]
                                ? services["CANDID PHOTOGRAPHY"]
                                  .uniqueClientCount
                                : 0) +
                              (services["TRADITIONAL VIDEOGRAPHY"]
                                ? services["TRADITIONAL VIDEOGRAPHY"]
                                  .serviceCount
                                : 0) +
                              (services["TRADITIONAL VIDEOGRAPHY"]
                                ? services["TRADITIONAL VIDEOGRAPHY"]
                                  .uniqueClientCount
                                : 0) +
                              (services["CINEMATOGRAPHY"]
                                ? services["CINEMATOGRAPHY"].serviceCount
                                : 0) +
                              (services["CINEMATOGRAPHY"]
                                ? services["CINEMATOGRAPHY"].uniqueClientCount
                                : 0) +
                              (services["HELICAM"]
                                ? services["HELICAM"].serviceCount
                                : 0) +
                              (services["HELICAM"]
                                ? services["HELICAM"].uniqueClientCount
                                : 0) +
                              (services["MIXER UNIT"]
                                ? services["MIXER UNIT"].serviceCount
                                : 0) +
                              (services["MIXER UNIT"]
                                ? services["MIXER UNIT"].uniqueClientCount
                                : 0) +
                              (services["LIVE STREAMING"]
                                ? services["LIVE STREAMING"].serviceCount
                                : 0) +
                              (services["LIVE STREAMING"]
                                ? services["LIVE STREAMING"].uniqueClientCount
                                : 0)
                            return sum + rowTotal
                          }, 0)}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                  <div className="font-size-14 mt-2">
                    <p>
                      {" "}
                      <p>{`Showing rows ${product_data && product_data.length > 0 ? 1 : 0
                        } to ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        } of ${product_data && product_data.length > 0
                          ? product_data.length
                          : 0
                        }`}</p>
                    </p>
                  </div>
                </Col>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      {downloadLoading ? (
        <Modal
          show={downloadLoading}
          style={{ width: "7%", margin: "18% 50%" }}
        >
          <Modal.Body>
            <Spinner
              as="span"
              animation="grow"
              size="lg"
              role="status"
              aria-hidden="true"
              variant="success"
              className="mx-2"
              color="success"
            />
          </Modal.Body>
        </Modal>
      ) : (
        ""
      )}
    </div>
  )
}
OtherBranchDataPendingReport.propTypes = {
  dispatch: PropTypes.func,
  searchBtnStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,OtherBranchDataPendingReport
})
//OtherBranchDataPendingReport
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OtherBranchDataPendingReport)
)
